import { useTranslation } from "react-i18next";
import { Briefcase, Download, FileSpreadsheet } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";
import { exportDutyReport } from "../../api/dutyReport";

// عنوان تقرير الواجبات + تصدير Excel و PDF (نفس نمط بقية التقارير).
export const DutyReportHeader = ({ filters }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <p className="label-xs flex items-center gap-2">
        <Briefcase className="h-4 w-4 text-primary" /> {t("reports.dutiesTitle")}
      </p>
      <div className="flex flex-wrap items-center gap-2">
        <NeuButton
          data-testid="duty-export-excel"
          className="flex items-center gap-2 px-3 py-2 text-xs"
          onClick={() => exportDutyReport("xlsx", i18n.language, filters)}
        >
          <FileSpreadsheet className="h-4 w-4" /> Excel
        </NeuButton>
        <NeuButton
          data-testid="duty-export-pdf"
          className="flex items-center gap-2 px-3 py-2 text-xs"
          onClick={() => exportDutyReport("pdf", i18n.language, filters)}
        >
          <Download className="h-4 w-4" /> PDF
        </NeuButton>
      </div>
    </div>
  );
};
